import React, { useState } from 'react';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Divider,
    DialogActions,
    MenuItem,
    Box,
    Checkbox,
    FormControlLabel,
    FormGroup,
    Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { withStyles } from '@mui/styles';
import { Styles } from '../../../../../config/design/styles';
import Grid from '@mui/material/Grid2';
import { useSnackbar } from 'notistack';
import LoadingButton from '../../../../components/elements/LoadingButton';
import axios from 'axios';
import { defaultVariables } from '../../../../../config';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AppCardLoaderFields from '../../../../components/loaders/AppCardLoaderFields';
import SubTitle from '../../../../components/elements/SubTitle';
import UserChooser from '../../../../components/elements/fields/UserChooser';
import { useIsSmall } from '../../../../../config/hooks/useWindowDimensions';
import CachedRoundedIcon from '@mui/icons-material/CachedRounded';
import RayaField from "../../../../components/elements/fields/RayaField";
const TransferStockButton = ({ classes, reload, item_id }) => {
    const [open, setOpen] = useState(false);
    const navigation = useNavigate();
    const { t } = useTranslation();
    const initFields = {
        bs_number:'',
    };
    const [fields, setFields] = useState(initFields);
    const [errors, setErrors] = useState({});
    const [stocks, setStocks] = useState([]);
    const [selectedStocks, setSelectedStocks] = useState([]);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [user_id, setUserId] = useState(null);
    const [receiver_id, setReceiverId] = useState(null);
    const isSmall = useIsSmall();
    const loginToken = localStorage.getItem('ACT');

    const closeDialog = () => {
        setOpen(false);
        setUserId(null);
        setReceiverId(null);
        setStocks([]);
        setSelectedStocks([]);
        setErrors({});
        setFields(initFields);
    };

    const handleValidation = async (callback) => {
        let formIsValid = true;
        let newErrors = {};

        if (!user_id) {
            formIsValid = false;
            newErrors.user = t('emptyField');
        }
        if (!receiver_id) {
            formIsValid = false;
            newErrors.receiver = t('emptyField');
        }
        if (!selectedStocks.length) {
            formIsValid = false;
            enqueueSnackbar(t('noStockSelected'), { variant: 'warning' });

        }
        if(!fields.bs_number){
            formIsValid = false;
            newErrors.bs_number = t('emptyField');
        }
        setErrors(newErrors);
        if (!formIsValid) setSubmitLoading(false);
        callback(formIsValid);
    };

    const fetchUserStocks = async (stocks) => {
        setLoading(true);
        setStocks(stocks);
        setSelectedStocks([]);
        setLoading(false);
    };
    const handleChange = (e) => {
        let { name, value } = e.target;
        setFields((prevFields) => ({ ...prevFields, [name]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };
    const handleRequest = async () => {
        const data = new FormData();
        data.append('sender_id', user_id);
        data.append('receiver_id', receiver_id);
        data.append('stocks', JSON.stringify(selectedStocks));
        data.append('bs_number', fields.bs_number);

        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            const response = await axios.post(`${defaultVariables.url}/stocks/transfer`, data, config);
            reload();
            setSubmitLoading(false);
            closeDialog();
            enqueueSnackbar(t('detailsSet'), { variant: 'success' });
        } catch (error) {
            console.error(error.response);
            setSubmitLoading(false);
            if (error.response.status === 403) {
                enqueueSnackbar(t('duplicateItemName'), { variant: 'warning' });
            } else {
                enqueueSnackbar(t('detailsSetFailed'), { variant: 'error' });
            }
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        handleValidation((valid) => {
            if (valid) handleRequest();
        });
    };

    return (
        <>
            <Button
                variant="contained"
                color="secondary"
                onClick={() => setOpen(!open)}
                startIcon={<CachedRoundedIcon />}
            >
                {t('transferStock')}
            </Button>
            <Dialog
                fullWidth
                maxWidth={'xs'}
                open={open}
                onClose={closeDialog}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle className="dialog-title" id="form-dialog-title">
                    {t('transferStock')}
                    <IconButton aria-label="close" className={classes.dialogClose} onClick={closeDialog}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent className="dialog-add-match">
                    <Grid container spacing={2}>
                        {loading ? (
                            <Grid item size={12}>
                                <AppCardLoaderFields height={300} />
                            </Grid>
                        ) : (
                            <>
                                <Grid item size={12}>
                                    <UserChooser
                                        handleRes={(user) => {
                                            if (!!user) {
                                                setUserId(user.id);
                                                fetchUserStocks(user.stock_numbers);
                                            }
                                        }}
                                        default_id={user_id}
                                        label={t('senderStock')}
                                        error={errors['user']}
                                        stockholders
                                    />
                                </Grid>
                                {stocks.length > 0 && (
                                    <Grid item size={12}>
                                        <SubTitle align="left">
                                            {t('selectStocksToTransfer')}
                                        </SubTitle>
                                        <Box
                                            sx={{
                                                backgroundColor: '#f5f5f5', // light gray
                                                padding: 2,
                                                borderRadius: 2,
                                                maxHeight: 200,
                                                overflowY: 'auto',
                                            }}
                                            style={{direction:"ltr"}}
                                        >
                                            <FormGroup>
                                                {stocks.map((stockNumber, index) => (
                                                    <FormControlLabel
                                                        key={index}
                                                        control={
                                                            <Checkbox
                                                                checked={selectedStocks.includes(stockNumber)}
                                                                color="secondary"
                                                                onChange={(e) => {
                                                                    const checked = e.target.checked;
                                                                    setSelectedStocks((prev) =>
                                                                        checked
                                                                            ? [...prev, stockNumber]
                                                                            : prev.filter((n) => n !== stockNumber)
                                                                    );
                                                                }}
                                                            />
                                                        }
                                                        label={`${stockNumber}${stockNumber.includes('S') ? ' (Special)' : ''}`}
                                                    />
                                                ))}
                                            </FormGroup>
                                        </Box>
                                        <Typography variant="body2" style={{ marginTop: 10 }}>
                                            {t('selectedStocksCount')}: {selectedStocks.length}
                                        </Typography>
                                    </Grid>
                                )}
                                <Grid item size={12}>
                                    <UserChooser
                                        handleRes={(user) => !!user && setReceiverId(user.id)}
                                        default_id={receiver_id}
                                        error={errors['receiver']}
                                        label={t('receiverStock')}

                                    />
                                </Grid>
                                <Grid item size={{xs:12}}>
                                    <RayaField
                                        variant="outlined"
                                        required
                                        fullWidth
                                        label={t('bsNumber')}
                                        name="bs_number"
                                        value={fields.bs_number}
                                        onChange={handleChange}
                                        error={!!errors.bs_number}
                                        helperText={errors.bs_number}
                                    />
                                </Grid>
                            </>
                        )}
                    </Grid>
                </DialogContent>
                <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
                    <LoadingButton
                        variant="contained"
                        color="secondary"
                        onClick={handleSubmit}
                        loading={submitLoading}
                    >
                        {t('transferStock')}
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default withStyles(Styles)(TransferStockButton);
